import { render, staticRenderFns } from "./communicate.vue?vue&type=template&id=5e36ac2c&scoped=true"
import script from "./communicate.vue?vue&type=script&lang=js"
export * from "./communicate.vue?vue&type=script&lang=js"
import style0 from "./communicate.vue?vue&type=style&index=0&id=5e36ac2c&prod&scoped=true&lang=css"
import style1 from "./communicate.vue?vue&type=style&index=1&id=5e36ac2c&prod&lang=css"
import style2 from "./communicate.vue?vue&type=style&index=2&id=5e36ac2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e36ac2c",
  null
  
)

export default component.exports